(ns dashboard.entity.document.diff-db
  "The principle contract of the dashboard.entity component namespaces are this:
     1. All components will NOT depend on keyword references to subs and events in
        external NSes, but rather receive data as arguments, functions and callbacks.
     2. All internal reliance on the re-frame app DB must be internally contained.
     3. All re-frame app subs and events must NOT be directly referenced by outside
        NSes, but rather via GETTER and SETTER functions - the same is true of internal
        calls - prefer using parameterized functions.
     4. The entity is a UI component that may encapsulate low-level business rules on
        UI controls, but is not responsible for hydrating components with data or entrenched
        references to component namespaces. The UI is customizable, and top-level entities
        should have configurable and interchangable UI elements."
  (:require
   [dashboard.services.http-config :as http-config]
   [dashboard.ui :as ui]
   [re-frame.core :as rf]))

;; ----------------------------------------------------------------------------
;;  Subscriptions
;; ----------------------------------------------------------------------------

(rf/reg-event-fx
 ::load-comparison-document
 (fn [_ [_ set-url2 {:keys [url]}]]
   (set-url2 url)
   {}))

(rf/reg-event-fx
 ::fetch-comparison-file-url
 (fn [_ [_ filename set-url2]]
   (let [download-url (str "/api/policies/files/" (js/encodeURIComponent filename))]
     {:http-xhrio
      {:method          :get
       :uri             (str download-url "/url")
       :timeout         http-config/timeout
       :response-format http-config/transit-response-format
       :on-success      [::load-comparison-document set-url2]
       :on-failure      [::ui/set-error "Could not get policy file URL"]}})))

(defn fetch-comparison-file-url
  [filename set-url2]
  (rf/dispatch [::fetch-comparison-file-url filename set-url2]))

(rf/reg-sub
 ::doc-diff
 (fn [db [_]]
   (get db :doc-diff)))

(defn doc-diff*
  []
  (rf/subscribe [::doc-diff]))

(rf/reg-event-db
 ::fetch-diff-success
 (fn [db [_ resp]]
   (assoc db :doc-diff resp)))

(rf/reg-event-fx
 ::fetch-diff
 (fn [_ [_ id1 id2]]
   {:http-xhrio
    {:method          :get
     :uri             "/api/document-difference/"
     :url-params      {:document-id-1 id1
                       :document-id-2 id2}
     :timeout         http-config/timeout
     :response-format http-config/transit-response-format
     :on-success      [::fetch-diff-success]
     :on-failure      [::ui/set-error "Could not load document diff"]}}))

(defn fetch-diff
  [doc-1-id doc-2-id]
  (rf/dispatch [::fetch-diff doc-1-id doc-2-id]))
